<template>
    <div>
        <ts-page-title :title="$t('monthlyAttendence.pageTitle')" :breadcrumb="[
            { text: $t('home'), href: '/' },
            {
                text: $t('monthlyAttendence.pageTitle'),
                active: true
            }
        ]" />
        <ts-panel>
            <ts-panel-wrapper>
                <div class="row">
                    <div class="col-md-2 form-group ts-px-2">
                        <label class="form-col-label control-label required ts-mb-2">{{
                            $t('monthlyAttendence.branchName')
                            }}</label>
                        <a-select class="ts-w-full" v-model="model.branch_id" :options="branches" showSearch
                            mode="multiple" :filterOption="(input, option) =>
                                option.componentOptions.children[0].text
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                                " :maxTagCount="1" :maxTagTextLength="17" :placeholder="$t('all')">
                        </a-select>
                        <div class="validate" v-if="errors.has('branch_id')">
                            {{ errors.first('branch_id') }}
                        </div>
                    </div>
                    <div class="col-md-2 form-group">
                        <label class="required col-md-3">{{ $t('monthlyAttendence.date') }}</label>
                        <div>
                            <a-range-picker class="ts-w-full" v-model="model.date_range" format="DD-MM-YYYY" />
                        </div>
                    </div>
                    <div class="col-md-2 form-group">
                        <label>{{ $t('monthlyAttendence.employeeName') }}</label>
                        <a-select class="ts-w-full" v-model="model.employee_id" :options="employees"
                            @change="onChangeEmployee" :showSearch="true" mode="multiple" :filterOption="(input, option) =>
                                option.componentOptions.children[0].text
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                                " :maxTagCount="1" :placeholder="$t('all')" :maxTagTextLength="17"
                            style="width: 100%"></a-select>
                    </div>
                    <div class="col-md-2 form-group">
                        <label>{{ $t('monthlyAttendence.position') }}</label>
                        <div>
                            <a-select class="ts-w-full" v-model="model.position_id" :options="positions"
                                :showSearch="true" mode="multiple" :filterOption="(input, option) =>
                                    option.componentOptions.children[0].text
                                        .toLowerCase()
                                        .indexOf(input.toLowerCase()) >= 0
                                    " :maxTagCount="1" :placeholder="$t('all')" style="width: 100%">
                            </a-select>
                        </div>
                    </div>
                    <div class="mt-4">
                        <ts-button class="btn-block" color="primary" :waiting="waiting" @click="preview">{{
                            $t('preview') }}</ts-button>
                    </div>
                </div>

            </ts-panel-wrapper>
            <div id="inquiry-list">
                <ts-loading-banner :loading="fetchDataLoading">
                    <div class="col-md-12">
                        <div class="row align-items-center">
                            <div class="col-auto d-flex align-items-center mt-1" v-for="(label, index) in legendLabels"
                                :key="index">
                                <div :class="legendBoxClass(index)" class="legend-box mr-1"></div>
                                <p class="mb-0" style="font-size: 11px;">{{ label }}</p>
                            </div>
                        </div>

                    </div>
                    <ts-table :records="resources" class="ts-mt-3" :rowClassName="() => 'no-hover-row'">
                        <template v-slot:thead>
                            <thead>
                                <tr>
                                    <th rowspan="2" class="ts-text-center ">
                                        {{ $t('monthlyAttendence.branch') }}
                                    </th>

                                    <th rowspan="2" class="ts-text-center ">
                                        {{ $t('monthlyAttendence.cardNumber') }}
                                    </th>

                                    <th rowspan="2" class="">
                                        {{ $t('monthlyAttendence.name') }}
                                    </th>
                                    <th rowspan="2" class="">
                                        {{ $t('monthlyAttendence.position') }}
                                    </th>
                                    <th rowspan="2" class="ts-text-center">
                                        {{ $t('monthlyAttendence.totalAbsence') }}
                                    </th>
                                    <th rowspan="2" class="ts-text-center">
                                        {{ $t('monthlyAttendence.totalLeave') }}
                                    </th>
                                    <th rowspan="2" class="color-y ts-text-center">
                                        {{ $t('monthlyAttendence.al') }}
                                    </th>
                                    <th rowspan="2" class="ts-text-center color-bloue">
                                        {{ $t('monthlyAttendence.sl') }}
                                    </th>
                                    <th rowspan="2" class="ts-text-center color-yb">
                                        {{ $t('monthlyAttendence.cl') }}
                                    </th>
                                    <th rowspan="2" class="ts-text-center color-purple">
                                        {{ $t('monthlyAttendence.ml') }}
                                    </th>
                                    <th rowspan="2" class="ts-text-center back-u">
                                        {{ $t('monthlyAttendence.u') }}
                                    </th>
                                    <th rowspan="2" class="ts-text-center bg-color">
                                        {{ $t('monthlyAttendence.el') }}
                                    </th>
                                    <th class="ts-text-center" v-for="(columns, index) in headers.date" :key="index"
                                        :value="columns">
                                        {{ columns }}
                                    </th>
                                </tr>
                                <tr>
                                    <th v-for="(columns, index) in dateString" :key="index" :value="columns">
                                        {{ columns.substring(0, 3) }}
                                    </th>
                                </tr>
                            </thead>
                        </template>
                        <template v-slot="{ record, index }">
                            <td class="ts-whitespace-no-wrap">{{ record.branch ? record.branch.branch_name_en : ''
                            }}
                            </td>
                            <td class="ts-whitespace-no-wrap text-center">{{ record.card_id }}
                            </td>
                            <td class="ts-whitespace-no-wrap">{{ record.employee_name_en }}
                            </td>
                            <td class="ts-whitespace-no-wrap">{{ record.position ? record.position.position_name_en
                                : ''
                            }}
                            </td>
                            <td class="ts-whitespace-no-wrap ts-text-center">
                                {{ absentCount(record.employee_scan) }}
                            </td>
                            <td class="ts-whitespace-no-wrap ts-text-center">
                                {{ totalLeave(record.employee_scan) }}
                            </td>
                            <td class="color-y ts-text-center ts-whitespace-no-wrap">
                                {{ alCount(record.employee_scan) }}
                            </td>
                            <td class="ts-text-center color-bloue ts-whitespace-no-wrap">
                                {{ slCount(record.employee_scan) }}
                            </td>
                            <td class="ts-text-center color-yb ts-whitespace-no-wrap">
                                {{ cCount(record.employee_scan) }}
                            </td>
                            <td class="ts-text-center color-purple ts-whitspeace-no-wrap">
                                {{ mlCount(record.employee_scan) }}
                            </td>
                            <td class="ts-text-center back-u ts-whitespace-no-wrap">
                                {{ unpaidCount(record.employee_scan) }}
                            </td>

                            <td class="ts-text-center bg-color ts-whitespace-no-wrap">
                                {{ elCount(record.employee_scan) }}
                            </td>
                            <td class="ts-text-center ts-whitespace-no-wrap" v-for="(dayNumber, date) in dateString"
                                :key="date" :class="coloring(
                                    getStatusByDayNumberInMonth(record.employee_scan, date)
                                )
                                    ">
                                {{ getStatusByDayNumberInMonth(record.employee_scan, date) }}
                            </td>
                        </template>
                    </ts-table>
                </ts-loading-banner>
            </div>
            <div class="d-flex justify-content-between align-items-center p-15">
                <ts-total-list v-model="pagination" />
                <ts-pagination v-model="pagination" @navigate="fetchDataDetail"></ts-pagination>
            </div>
        </ts-panel>

    </div>
</template>
<script>
import { Errors } from 'form-backend-validation'
import moment from 'moment'
import { mapActions, mapState } from 'vuex';
import { sumBy } from 'lodash'

export default {
    name: 'monthlyAttendence',
    data() {
        return {
            loading: false,
            fetchDataLoading: false,
            waiting: false,
            exporting: false,
            errors: new Errors(),
            departments: [],
            employees: [],
            positions: [],
            headers: [],
            dateString: [],
            holidays: [],
            branches: [],
            attendanceRecords: [],
            legendLabels: [
                'AL : Annual Leave',
                'SL : Sick Leave',
                'CL : Compensation Leave',
                'ML : Maternity Leave',
                'UL : Unpaid Leave',
                'EL : Early Leave',
                'A  : Absence'
            ],
            model: {
                branch_id: [],
                department_id: [],
                employee_id: [],
                position_id: [],
                date_range: [moment(), moment()]

            }
        }
    },

    created() {
        this.getBranch();
        this.model.branch_id = this.$store.state.authUser.user.default_branch.branch_id
        this.getEmployee()
        this.getHoliday()

    },
    computed: {
        ...mapState('humanResource/monthlyAttendence', ['resources', 'pagination']),
        coloring: () => att => {
            const colorMap = {
                'A': 'color color-red',
                'P': 'color color-primary',
                'AL: 1': 'color color-y',
                'AL: 0.5': 'color color-y',
                'ML: 1': 'color color-purple',
                'ML: 0.5': 'color color-purple',
                'SL: 1': 'color color-blue',
                'SL: 0.5': 'color color-blue',
                'EL: 1': 'color bg-color',
                'EL: 0.5': 'color bg-color',
                'U: 1': 'color back-u',
                'U: 0.5': 'color back-u',
                'SPL: 1': 'color color-blue',
                'SPL: 0.5': 'color color-blue',
                'CL: 1': 'color color-cl',
                'CL: 0.5': 'color color-cl',
                'PH': 'color ph',
                'x': 'color color-black'
            }

            return colorMap[att] || ''
        },
        leaveCount() {
            return (attRecord, leaveType) => {
                if (!attRecord) return 0;
                return attRecord
                    .filter(a => a.leave_type_en === leaveType)
                    .reduce((total, a) => total + parseFloat(a.total_leave_day), 0);
            };
        },

        statusCount: () => (attRecord, status) => {
            if (!attRecord) return 0
            return attRecord.filter(a => a.att_status === status).length
        },
        alCount() {
            return attRecord => this.leaveCount(attRecord, 'Annual Leave');
        },
        slCount() {
            return attRecord => this.leaveCount(attRecord, 'Sick Leave')
        },
        mlCount() {
            return attRecord => this.leaveCount(attRecord, 'Maternity Leave')
        },
        elCount() {
            return attRecord => this.leaveCount(attRecord, 'Early leave')
        },
        cCount() {
            return attRecord => this.leaveCount(attRecord, 'Compensation Leave')
        },
        unpaidCount() {
            return attRecord => this.leaveCount(attRecord, 'Unpaid Leave')
        },

        absentCount() {
            return attRecord => this.statusCount(attRecord, 'Absent')
        },

        totalLeave() {
            return attRecord => {
                if (!attRecord) return 0
                const leaveData = attRecord.filter(a => a.att_status === 'Leave')
                return sumBy(leaveData, 'total_leave_day')
            }
        },
        getStatusByDayNumberInMonth: vm => (scanData, date) => {
            const targetDate = moment(date, 'DD-MM-YYYY').format('YYYY-MM-DD');

            const findHolidayByDate = vm.holidays.find(h => {
                const holDate = moment(h.holiday_date, 'DD-MM-YYYY').format('YYYY-MM-DD');
                return holDate === targetDate;
            });

            if (scanData !== null && Array.isArray(scanData)) {
                const dayRecords = scanData.filter(s => s.datescan === targetDate);

                if (dayRecords.length > 0) {
                    if (dayRecords.some(d => d.att_status === 'Present')) return 'P';

                    if (dayRecords.some(d => d.att_status === 'Absent')) return 'A';

                    const leaveMap = {
                        'Annual Leave': 'AL',
                        'Maternity Leave': 'ML',
                        'Sick Leave': 'SL',
                        'Early leave': 'EL',
                        'Unpaid Leave': 'U',
                        'Special Leave': 'SPL',
                    };

                    const leavesByType = {};

                    dayRecords.forEach(record => {
                        if (record.leave_type_en) {
                            const leaveKey = record.leave_type_en;
                            const leaveDays = parseFloat(record.total_leave_day) || 0;
                            if (!leavesByType[leaveKey]) {
                                leavesByType[leaveKey] = 0;
                            }
                            leavesByType[leaveKey] += leaveDays;
                        }
                    });

                    const leaveStatuses = Object.entries(leavesByType).map(([type, totalDays]) => {
                        const short = leaveMap[type];
                        if (!short) return null;
                        const daysStr = totalDays % 1 === 0 ? totalDays.toString() : totalDays.toFixed(1);
                        return `${short}: ${daysStr}`;
                    }).filter(Boolean);

                    if (leaveStatuses.length > 0) {
                        return leaveStatuses.join(', ');
                    }
                }

                if (findHolidayByDate) {
                    return 'PH';
                }

                return 'x';
            }

            return 'x';
        }


    },
    methods: {
        ...mapActions('humanResource/monthlyAttendence', ['getEmployee', 'getPosition']),
        legendBoxClass(index) {
            return [
                'box-al', 'box-sl', 'box-c', 'box-ml', 'box-u', 'box-el', 'box-a'
            ][index] || 'box-al';
        },
        fetchDataDetail(attributes) {
            this.fetchDataLoading = true
            this.error = new Errors()
            this.$store
                .dispatch(
                    'humanResource/monthlyAttendence/fetch',
                    Object.assign(
                        {},
                        this.model,
                        {
                            branch_id: this.model.branch_id,
                            department_id: this.model.department_id,
                            date_range: [
                                this.model.date_range[0].format('DD-MM-YYYY'),
                                this.model.date_range[1].format('DD-MM-YYYY')
                            ]
                        },
                        attributes
                    )
                )
                .catch(error => {
                    this.$toasted.error(error.message)
                    this.errors = new Errors(error.errors)
                })
                .finally(() => (this.fetchDataLoading = false))
        },
        async getBranch() {
            this.loading = true
            await this.$store
                .dispatch('security/user/getBranchAssigned')
                .then(response => {
                    this.branches = response.data.map(el => ({
                        value: el.branch_id,
                        label: el.branch_name_en
                    }))

                })
                .catch(error => {
                    this.$toasted.error(error.message)
                })
                .finally(() => {
                    this.loading = false
                })
        },
        getEmployee() {
            this.$store.dispatch('humanResource/monthlyAttendence/getEmployee').then(response => {
                this.employees = response.data.map(el => ({
                    value: el.employee_id,
                    label: el.employee_name_en
                }))
            })
        },

        onChangeEmployee() {
            this.model.position_id = []
            this.getPosition({
                filter: {
                    employee_id: this.model.employee_id
                }
            }).then(response => {
                this.positions = response.data.map(el => ({
                    value: el.position_id,
                    label: el.position_name_en
                }))
            })
        },
        getHoliday() {
            this.holidays.length = 0
            this.$store
                .dispatch(
                    'humanResource/monthlyAttendence/getHoliday',
                    Object.assign({}, this.model, {
                        branch_id: this.branch_id,
                        employee_id: this.model.employee_id,
                        date_range: [
                            this.model.date_range[0].format('DD-MM-YYYY'),
                            this.model.date_range[1].format('DD-MM-YYYY')
                        ]
                    })
                )
                .then(res => {
                    this.holidays = res.data
                })
                .catch(error => {
                    this.$toasted.error(error.message)
                    this.errors = new Errors(error.errors)
                })
                .finally(() => (this.loading = false))
        },
        preview(attributes) {
            this.waiting = true
            this.errors = new Errors()
            this.$store
                .dispatch(
                    'humanResource/monthlyAttendence/getHeader',
                    Object.assign(
                        {},
                        this.model,
                        {
                            branch_id: this.model.branch_id,
                            employee_id: this.model.employee_id,
                            date_range: [
                                this.model.date_range[0].format('DD-MM-YYYY'),
                                this.model.date_range[1].format('DD-MM-YYYY')
                            ]
                        },
                        attributes
                    )
                )
                .then(response => {
                    this.dateString = response['dateString']
                    this.headers = response['columnHeaders']
                    this.fetchDataDetail()
                    this.getHoliday()
                    this.loading = false
                })
                .catch(error => {
                    this.$toasted.error(error.message)
                    this.errors = new Errors(error.errors)
                })
                .finally(() => {
                    this.waiting = false
                })
        },
    }
}
</script>
<style scoped>
#inquiry-list {
    max-height: 60vh;
    overflow: auto;
}

table>tbody>tr td {
    vertical-align: middle;
    padding: 4px 6px
}

.table>thead>tr>th {
    vertical-align: middle;
    border: 1px solid #b6c2c9;
    white-space: nowrap;
    padding: 4px 6px
}


table tr:hover td {
    background-color: transparent !important;
    color: inherit !important;
    transition: none !important;
}

::-webkit-scrollbar {
    height: 8px;
    width: 3px;
    /* Remove scrollbar space */
    background: #ffff;
    /* Optional: just make scrollbar invisible */
}

/* Optional: show position indicator in red */
::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background: #e5e7e7;
}

div::-webkit-scrollbar-thumb:hover {
    background: #b7b7b8;
}

.color-y {
    background-color: #fff3cd;
}

.color-bloue {
    background-color: #d1ecf1;
}

.color-yb {
    background-color: #fcf8e3;
}

.color-purple {
    background-color: #e8daef;
}

.color-red {
    background-color: #e84641;
}

.color-greend {
    background-color: #d4edda;
}

.bg-color {
    background-color: #e2f0d9;
}

.color-black {
    background-color: #f5f6f8;
}

.back-u {
    background-color: #d1f2eb;
}

.ph {
    background-color: #e84641;
}

.box-al,
.box-sl,
.box-c,
.box-ml,
.box-u,
.box-el,
.box-a {
    width: 20px;
    height: 18px;
    padding: 2px;
    margin: 5px 5px 5px 0;
    border-radius: 2px;
    box-shadow: 2px 2px 6px rgba(0, 0, 0, 0.1);
}

.box-al {
    background-color: #fff9db;
    border: 1px solid #fff9db;
}

.box-sl {
    background-color: #e0f4fb;
    border: 1px solid #e0f4fb;
}

.box-c {
    background-color: #f2f3cf;
    border: 1px solid #f2f3cf;
}

.box-ml {
    background-color: #f2e5f7;
    border: 1px solid #f2e5f7;
}

.box-u {
    background-color: #e5f9f3;
    border: 1px solid #e5f9f3;
}

.box-el {
    background-color: #d8fbd8;
    border: 1px solid #d8fbd8;
}

.box-a {
    background-color: #e84641;
    border: 1px solid #e84641;
}

.title {
    margin-top: 9px;
    font-size: 14px;
}

@media (max-width: 992px) {
    .title {
        font-size: 13px;
        margin-top: 10px;
    }

    .box-al,
    .box-sl,
    .box-c,
    .box-ml,
    .box-u,
    .box-el,
    .box-a {
        width: 22px;
        height: 18px;
        margin: 5px 5px 5px 0;
    }
}

@media (max-width: 576px) {
    .title {
        font-size: 10px;
        margin-top: 8px;
    }

    .box-al,
    .box-sl,
    .box-c,
    .box-ml,
    .box-u,
    .box-el,
    .box-a {
        width: 18px;
        height: 16px;
    }

    table {
        font-size: 12px;
    }

    ::v-deep .no-hover-row:hover td {
        background-color: transparent !important;
        color: inherit !important;
        transition: none !important;
    }

    .legend-box {
        width: 16px;
        height: 16px;
        border-radius: 2px;
    }
}
</style>
